import fastForward from '../../../../../../assets/icons/fastForward.svg';
import cls from './FastForwardButton.module.scss';
interface FastForwardProps {
    onFastForward: () => void;
}

const FastForwardButton = ({onFastForward}: FastForwardProps) => (
    <button
        className={cls.button}
        onClick={onFastForward}
    >
        {<img src={fastForward} alt="fastForward"/>}
    </button>
);
export default FastForwardButton;